export default __webpack_public_path__ + "static/media/archywavelogoss.e249e3d3.png";